$.plugins.roller = {
	value: 0,
	values: [],
	labels: null,
	
	__init: function (config) {
		this.apply('widget', { label: config.label }).addClass('roller');
		
		this.items = [];
		
		this.container = $.div().addClass('container').appendTo(this);
		this.slider = $.div().addClass('slider').appendTo(this.container);
		
		if (config.values) {
			this.reset(config.values);
		}
		
		var roller = this;
		var isdown = false;
		var zero = null;
		var em = null;
		this.container.on('touchstart', function (e) {
			isdown = true;
			em = parseFloat(window.getComputedStyle(roller.el).fontSize);
			roller.slider.removeClass('transition');
			
			var touch = (e.touches[0] || e.changedTouches[0]);
			zero = touch.clientY;
		});
		
		$(document).on('touchmove', function (e) {
			if (!isdown) {
				return;
			}
			
			var touch = (e.touches[0] || e.changedTouches[0]);
			var shift = -roller.value * 2.5 + (touch.clientY - zero) / em;
			roller.slider.css('transform', 'translateY(' + shift + 'em)');
			roller.slider.css('-webkit-transform', 'translateY(' + shift + 'em)');
		});
		
		$(document).on('touchend', function (e) {
			if (!isdown) {
				return;
			}
			
			isdown = false;
			
			var touch = (e.touches[0] || e.changedTouches[0]);
			var shift = -roller.value * 2.5 + (touch.clientY - zero) / em;
			var value = Math.round(-shift / 2.5);
			
			value = Math.min(Math.max(value, 0), roller.values.length - 1);
			
			roller.set(roller.values[value]);
		});
	},
	
	reset: function (values, value, labels) {
		this.values = values;
		this.labels = labels;
		this.value = value || 0;
		
		while (this.value < 0) {
			this.value += this.values.length;
		}
		
		this.slider.empty();
		this.items = [];
		
		for (var i = 0; i < this.values.length; i++) {
			value = this.values[i];
			if (typeof value === 'number') {
				
				if(value >= 1000000000) {
					value = value/1000000000 + 'B';
				}
				
				else if(value >= 1000000 && value < 1000000000) {
					value = value/1000000 + 'M';
				}
				
				else if(value >= 10000 && value < 1000000) {
					value = value / 1000 + 'K';
				}
		
				else {
					value = $.plugins.meter.__format(value);
				}
			}
			
			var label = (this.labels && this.labels[i]) ? this.labels[i] : value;
			
			var item = $.div().addClass('option').apply('widget', { label: label });
			
			item.appendTo(this.slider);
			this.items.push(item);
		}
		
		this.trigger('reset');
		
		this.update();
		
		return this;
	},
	
	update: function () {
		var value = this.values[this.value];
		
		if (typeof value === 'number') {
			value = $.plugins.meter.__format(value);
		}
		
		this.slider.addClass('transition');
		setTimeout($p.removeClass.bind(this.slider, 'transition'), 250);
		
		
		var shift = -this.value * 2.5;
		this.slider.css('transform', 'translateY(' + shift + 'em)');
		this.slider.css('-webkit-transform', 'translateY(' + shift + 'em)');
		
		this.trigger('update', { value: this.values[this.value], label: (this.labels && this.labels[this.value]) ? this.labels[this.value] : null });
		
		return this.values[this.value];
	},
	
	get: function (label) {
		return (label && this.labels && this.labels[this.value]) ? this.labels[this.value] : this.values[this.value];
	},
	
	set: function (value) {
		this.value = this.values.indexOf(value);
		
		if (this.value < 0) {
			this.value = 0;
		}
		
		return this.update();
	},
	
	dec: function () {
		if (this.disabled) {
			return;
		}
		
		if (this.value - 1 < 0) {
			return this.update();
		}
		
		this.value = (this.value - 1 + this.values.length) % this.values.length;
		
		if (this.value < 0) {
			this.value = 0;
		}
		
		return this.update();
	},
	
	inc: function () {
		if (this.disabled) {
			return;
		}
		
		this.value = (this.value + 1) % this.values.length;
		
		return this.update();
	},
	
	max: function () {
		if (this.disabled) {
			return;
		}
		
		this.value = this.values.length - 1;
		
		return this.update();
	},
};



/** WEBPACK FOOTER **
 ** ./../../../../engine/public-src/spingames/panel/js/roller.js
 **/